import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.find.js";
var DuelTabs = function DuelTabs() {
  return import('@/components/organisms/DuelTabs');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
var ExternalLink = function ExternalLink() {
  return import('@/components/atoms/ExternalLink');
};
import Nl2br from 'vue-nl2br';
var LazyImage = function LazyImage() {
  return import('@/components/atoms/LazyImage');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
export default {
  components: {
    DuelTabs: DuelTabs,
    PrimeIcon: PrimeIcon,
    ExternalLink: ExternalLink,
    PageTitle: PageTitle,
    Nl2br: Nl2br,
    LazyImage: LazyImage,
    Modal: Modal
  },
  data: function data() {
    return {
      isEntried: false,
      isModalShown: false,
      shownHelpType: 0,
      publicArenasCount: 0,
      finishedArenas: [],
      userTmInfos: [],
      tmNumberOfChallenged: 0,
      tmRemainingOfNumber: 0,
      tmChallengeLimit: 0,
      rmRemainingOfNumber: 0,
      rmChallengeLimit: 0
    };
  },
  computed: {
    userRmInfo: function userRmInfo() {
      return useRankMatchStore().getJoinedUserInfoAny;
    },
    getShownRankMatchMasters: function getShownRankMatchMasters() {
      return useRankMatchStore().getShownRankMatchMasters;
    },
    getShownTitleMatchMasters: function getShownTitleMatchMasters() {
      return useTitleMatchStore().getShownTitleMatchMasters;
    },
    getArenaTypeModalHeader: function getArenaTypeModalHeader() {
      if (this.shownHelpType == 1) {
        return this.$t('help.title.titleMatch.top');
      } else if (this.shownHelpType == 2) {
        return this.$t('help.title.cups.userMatch.top');
      } else if (this.shownHelpType == 3) {
        return this.$t('help.title.rankMatch.top');
      }
      return '';
    },
    getArenaTypeModalContent: function getArenaTypeModalContent() {
      if (this.shownHelpType == 1) {
        return this.$t('help.detail.titleMatch.top');
      } else if (this.shownHelpType == 2) {
        return this.$t('help.detail.cups.userMatch.top');
      } else if (this.shownHelpType == 3) {
        return this.$t('help.detail.rankMatch.top');
      }
      return '';
    },
    userTmInfo: function userTmInfo() {
      return this.userTmInfos.find(function (x) {
        return x.isjoined;
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.fetchUserInfo();
          case 2:
            _context.next = 4;
            return _this.getPublicArenas();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getTitleMatchName: function getTitleMatchName(titleMatchId) {
      return useTitleMatchMaster().getTitleMatchName(titleMatchId);
    },
    getRankMatchName: function getRankMatchName(rankMatchId) {
      return useRankMatchMaster().getRankMatchName(rankMatchId);
    },
    getCupPeriodStr: function getCupPeriodStr(period) {
      var sinceStr = this.$dayjs(period.since * 1000).format('LLL');
      var untilStr = this.$dayjs(period.until * 1000).format('LLL');
      return "".concat(sinceStr, " - ").concat(untilStr);
    },
    getIsFinished: function getIsFinished(period) {
      var until = this.$dayjs(period.until * 1000);
      return this.$dayjs().isAfter(until);
    },
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var counts;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this2.getShownTitleMatchMasters.forEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(x) {
                  var userTmInfo, counts;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return _this2.$duelsService.getMyTmUserInfo(x.titleMatchId);
                      case 2:
                        userTmInfo = _context2.sent;
                        userTmInfo.titleMatchId = x.titleMatchId;
                        _this2.userTmInfos.push(userTmInfo);
                        if (!_this2.userTmInfo) {
                          _context2.next = 13;
                          break;
                        }
                        _context2.next = 8;
                        return _this2.$duelsService.getTmNumberOfChallenged(_this2.userTmInfo.titleMatchId);
                      case 8:
                        counts = _context2.sent;
                        _this2.tmChallengeLimit = counts.maxCounts;
                        _this2.tmNumberOfChallenged = counts.counts;
                        _this2.tmRemainingOfNumber = _this2.tmChallengeLimit - _this2.tmNumberOfChallenged;
                        if (_this2.tmRemainingOfNumber <= 0) _this2.tmRemainingOfNumber = 0;
                      case 13:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context3.next = 3;
              return useRankMatchStore().fetchMyUserInfos();
            case 3:
              if (!(_this2.userRmInfo && !_this2.getIsFinished(_this2.getShownRankMatchMasters.find(function (x) {
                return x.rankMatchId == _this2.userRmInfo.rankMatchId;
              }).eventPeriod))) {
                _context3.next = 9;
                break;
              }
              _context3.next = 6;
              return _this2.$duelsService.getUftWinCounts(_this2.userRmInfo.rankMatchId);
            case 6:
              counts = _context3.sent;
              _this2.rmChallengeLimit = counts.maxCounts;
              _this2.rmRemainingOfNumber = counts.counts;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // async clickConfirm(selectedCupId) {
    //   if (this.userInfo.joinedCupId === selectedCupId) {
    //     await this.$router.push(
    //       this.localePath({ name: 'cups-cupId-index-users', params: { cupId: selectedCupId } })
    //     )
    //   } else {
    //     await this.$router.push(
    //       this.localePath({ name: 'cups-cupId-index-detail', params: { cupId: selectedCupId } })
    //     )
    //   }
    // },
    // isShownIcon(cupMaster) {
    //   return (
    //     (this.userInfo.joinedCupId && this.userInfo.joinedCupId == cupMaster.cupId) ||
    //     this.getCupClass(cupMaster.cupId) ||
    //     cupMaster.rules.isPrimeOnly
    //   )
    // },
    shownHelpModal: function shownHelpModal(type) {
      this.isModalShown = true;
      this.shownHelpType = type;
    },
    toJoinArean: function toJoinArean(type) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(type == 1)) {
                _context4.next = 5;
                break;
              }
              _context4.next = 3;
              return _this3.$router.push(_this3.localePath({
                name: 'titlematch-titleMatchId-index-users',
                params: {
                  titleMatchId: _this3.userTmInfo.titleMatchId
                }
              }));
            case 3:
              _context4.next = 7;
              break;
            case 5:
              _context4.next = 7;
              return _this3.$router.push(_this3.localePath({
                name: 'rankmatch-rankMatchId-index',
                params: {
                  rankMatchId: _this3.userRmInfo.rankMatchId
                }
              }));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getPublicArenas: function getPublicArenas() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var publicArenas;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this4.$arenaService.getOngoingPublicArenaPasswords(0, 10000);
            case 2:
              publicArenas = _context5.sent;
              _this4.publicArenasCount = publicArenas.passwordsList.length;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    } // async getFinishedArenas() {
    //   const finishedArenas = await this.$arenaService.getCompletedArenaIds(0,20)
    //   const finishedArenaDetails = await Promise.all(
    //     finishedArenas.arenaIdsList.map(arenaId =>
    //       this.$arenaService.getArenaInfo(arenaId)
    //     )
    //   )
    //   console.log(this.$dayjs(finishedArenaDetails[0].battledAt, 'X').format('YYYY-MM-DD'))
    //   console.log(this.$dayjs().format('YYYY-MM-DD'))
    //   return this.finishedArenas = finishedArenaDetails
    // },
  }
};